import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=f7b001d8&scoped=true"
import script from "./buttons.vue?vue&type=script&lang=ts"
export * from "./buttons.vue?vue&type=script&lang=ts"
import style0 from "./buttons.vue?vue&type=style&index=0&id=f7b001d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b001d8",
  null
  
)

export default component.exports